module.exports = __webpack_public_path__ + "static/img/icon_success.d7f435fd.png";